export enum ViewID {
    ADD_TO_CART_STATUS = 'ADD_TO_CART_STATUS',
    SHIPPING = 'SHIPPING',
    PRODUCTS = 'PRODUCTS',
    RESULTS = 'RESULTS',
}
